module.exports = __webpack_public_path__ + "static/media/Timer_WAITING@3x.ef42bb98.png";